// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'
import UnfavoriteController from "./view/unfavorite_controller"
import MapPopupController from "./search/map_popup_controller"

application.register("unfavorite", UnfavoriteController)
application.register("map-popup", MapPopupController)
